var controllers = require('./controllers'),
  elements = require('./elements');
const keyMirror = require('fbjs/lib/keyMirror');


exports.applyExtensions = function (Chart) {
  elements.image(Chart);
  controllers.rawImage(Chart);
};

exports.types = keyMirror({
  rawImage: null
});
